import api from "../api/axiosConfig";

const USER_KEY = "app_auth";


export const getCSRFToken = async () => {
  const cookieToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('csrftoken='))
    ?.split('=')[1];

  if (cookieToken) {
    console.debug('Found CSRF token in cookies');
    return cookieToken;
  }

  try {
    const response = await api.get('/get-csrf/'); 
    const token = response.data.csrfToken;       

    if (token) {
      console.debug('Retrieved fresh CSRF token from server');
      return token;
    }
    return null;
  } catch (error) {
    console.error('CSRF token fetch failed:', error);
    return null;
  }
};


export const setAuthData = (data) => {
  try {
    sessionStorage.setItem(USER_KEY, JSON.stringify({
      user: data.user,
      timestamp: Date.now()
    }));
  } catch (e) {
    console.error("Storage set error:", e);
  }
};

export const getAuthData = () => {
  try {
    const data = sessionStorage.getItem(USER_KEY);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error("Storage get error:", e);
    return null;
  }
};